import type {PropsWithChildren} from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../../../hooks/typography';

import styles from './styles.module.css';

export function Content(props: PropsWithChildren<unknown>) {
    const typographyCls = useTypography({
        size: TypographySize.BodyL,
    });

    return <span className={classNames(typographyCls, styles.content)}>{props.children}</span>;
}
